import { useMutation, useQueryClient } from '@tanstack/react-query';

import { importApi } from '../api/import.api.js';

export function useImportGoodreads() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (csv: string) => importApi.importGoodreads(csv),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['shelf'] });
    },
  });
}
